import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

import axios from "axios";



const initialState = {
    entities: {
        SelectedAssessmentProduct: null
        , ReportGuid: null
        , GroupGuidList: []
        , NotCompletedInRange: false
        , CompletedInRange: true
        , NotStartedInRange: false
        , StartedInRange: true
        , NotModifiedInRange: false
        , ModifiedInRange: false
        , NotFirstCompletedInRange: false
        , FirstCompletedInRange: false
    
    },
    status: 'idle', // idle loading success fail  
    error: null
}

const PLATFORM = '../../WsWebServicePlatform/'

//Admin/ReportCriteria/Set/{AuthToken}/	
export const updateReportCriteria = createAsyncThunk('reportcriteria/update', async (incomingVariable, thunkAPI) => {
    const state = thunkAPI.getState()

    const bodies = {ReportCriteria:{...incomingVariable.ReportCriteria
        , HRANotCompletedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.NotCompletedInRange === true ? "1" : "0"
        , HRACompletedInDateRange: incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.CompletedInRange === true ? "1" : "0"
        , HRANotStartedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.NotStartedInRange === true ? "1" : "0"
        , HRAStartedInDateRange: incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.StartedInRange === true ? "1" : "0"
        , HRANotModifiedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.NotModifiedInRange === true ? "1" : "0"
        , HRAModifiedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.ModifiedInRange === true ? "1" : "0"
        , HRANotFirstCompletedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.NotFirstCompletedInRange === true ? "1" : "0"
        , HRAFirstCompletedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.FirstCompletedInRange === true ? "1" : "0"
        , IncludeAdditionalQuestions:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.IncludeAdditionalQuestions === true ? "1" : "0"
        , ExcludeInactiveParticipants:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.ExcludeInactiveParticipants === false ? "1" : "0"
        , ReportOutputFormat: "JSON"  
        , FirstRowHeader: "1"
    }}
    try {
        const response = await axios.post(PLATFORM + "Admin/ReportCriteria/Set/" + incomingVariable.AuthToken + "/",bodies)
        const data = await response.data        
        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})
const reportcriteriaSlice = createSlice({
    name: 'reportcriterias',
    initialState,
    reducers: {
        reportcriteriaClear(state, action) {
            state.entities = initialState.entities
        },
        reportcriteriaModify(state, action) {
            const reportcriteriaData = action.payload
            state.entities[reportcriteriaData.Key] = reportcriteriaData.Value
        },

        reportcriteriaDelete(state, action) {
            const reportcriteriaData = action.payload
            delete state.entities[reportcriteriaData.Key]
        },
        reportcriteriaHydrate(state, action) {
            const reportcriteriaData = action.payload
            state.entities = reportcriteriaData
            state.status = 'success'
        },
        reportcriteriaResetStatus(state, action){
            state.status='idle'
        }
    },
        extraReducers(builder) {
      builder
        .addCase(updateReportCriteria.pending, (state, action) => {
          state.status = 'loading'
        })
        .addCase(updateReportCriteria.fulfilled, (state, action) => {
            const Success = action.payload.Success
            if (Success === true) {
                state.error = null
                state.status = 'success'                                
            } else {
                state.status = 'failed'
                state.error = action.payload.Status[0]
            }
        })
        .addCase(updateReportCriteria.rejected, (state, action) => {
          state.error = action.error.message
          console.log('failed')
        })
    }
})

export const { reportcriteriaClear, reportcriteriaModify, reportcriteriaDelete, reportcriteriaHydrate,reportcriteriaResetStatus } = reportcriteriaSlice.actions

export default reportcriteriaSlice.reducer

export const selectReportCriteriaEntities = (state) => state.reportcriterias.entities

export const selectReportCriterias = createSelector(selectReportCriteriaEntities, (entities) =>
    Object.values(entities)
)

export const selectReportCriteriaById = (state, ReportCriteriaId) => {
    return selectReportCriteriaEntities(state)[ReportCriteriaId]
}

